import axios from 'axios';
import Cookies from 'js-cookie';
import head from 'lodash/head';
import intersection from 'lodash/intersection';
import { v4 } from 'uuid';
import { CHECKOUT_RELEASE_INVENTORY, SHARE_CART_VIA_EMAIL_ENDPOINT, SHIPPING_METHODS_ENDPOINT, } from '@yme/common/endpoints';
import { decreaseStockProduct } from '@yme/components/ProductDetailsPage/redux/actions';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS, ModalState } from '@yme/modals/constants';
import { ACTIVE_DEALER_SESSION_KEY } from '@yme/organisms/preferred-dealer/constants';
import { setPixelEvent, PixelEvent } from '@yme/utils/bloomreach';
import { DigitalDataMutation, getFormattedLanguageRoot, setDigitalData } from '@yme/utils/common';
import { CartBroadcastEvents, HTTPStatusCode, METHOD_GET, METHOD_POST } from '@yme/utils/constants';
import { getCustomerId } from '@yme/utils/externalCustomer';
import { broadcastCart } from '../../../App';
import { serviceAPI } from '../../../utils/api';
import { addProductExternalToCartFailure, addProductExternalToCartSuccess, addProductToCartFailure, addProductToCartRequest, addProductToCartSuccess, addProductToExternalCartRequest, changeItemQuantityFailure, changeItemQuantityRequest, changeItemQuantitySuccess, changeShippingMethodFailure, changeShippingMethodSuccess, getCartFailure, getCartRequest, getCartSuccess, getExternalCartFailure, getExternalCartSuccess, getShippingMethodsSuccess, setCartErrorData, setCartQrId, setDeletingCartItems, setInitialCartState, setIsLoadingCart, updateDiscountCodeFailure, updateDiscountCodeRequest, updateDiscountCodeSuccess, updateStockQuantityProduct, } from './actions';
import { CART_ID_SEPARATOR, CART_SOURCE, CartAction, CartErrorMessage, COOKIE_CART_ID_EXPIRE, COOKIE_CART_ID_KEY, DEALER_CART_SHARED_ID, EXTERNAL_CUSTOMER_ID, HOSTETTLER_ERROR_STATES, PAYMENT_LINK_PROVIDER, ShippingMethodsGroups, TypeId, } from './constants';
import { generateCartLink, getProductsDataForEmail, getHasProductDeliverAtDealerOnly, } from './helpers';
export const addProductToCart = (sku, quantity, currency, apiUrlCreateCart, apiUrlUpdateCart, preparedProductsUrls) => {
    let cartId = Cookies.get(COOKIE_CART_ID_KEY);
    return async (dispatch, getState) => {
        dispatch(addProductToCartRequest({
            sku: head(sku) || '',
            quantity,
        }));
        const { common: { currentCountryRoot, languageRootPath, bloomreachModel, isInAuthor }, cart: { data }, productDetailsPage, } = getState();
        let isAddNewProduct;
        if (data) {
            isAddNewProduct = !data.entries.some((entry) => sku.includes(entry.product.variants[0].sku));
        }
        else {
            isAddNewProduct = true;
        }
        try {
            if (!cartId) {
                const axiosConfig = {
                    data: {
                        anonymousId: v4(),
                        country: currentCountryRoot.toUpperCase(),
                        currency,
                        cartSource: CART_SOURCE,
                    },
                    method: METHOD_POST,
                    url: apiUrlCreateCart,
                };
                const answer = await axios.request(axiosConfig);
                const { id } = answer.data;
                cartId = id;
                Cookies.set(COOKIE_CART_ID_KEY, cartId, {
                    expires: COOKIE_CART_ID_EXPIRE,
                    path: `${languageRootPath}/`,
                });
            }
            const actions = sku.map((productSku, index) => {
                const pathName = preparedProductsUrls.find((item) => item.sku == productSku)?.productUrl || '';
                return {
                    action: CartAction.ADD_LINE_ITEM,
                    value: {
                        quantity: index === 0 ? quantity : 1,
                        sku: productSku,
                        ...(pathName
                            ? {
                                pathName,
                            }
                            : {}),
                    },
                };
            });
            const axiosConfig = {
                data: {
                    actions,
                },
                method: METHOD_POST,
                url: apiUrlUpdateCart.replace(CART_ID_SEPARATOR, cartId),
            };
            const answer = await axios.request(axiosConfig);
            // B2C-20664
            sessionStorage.removeItem(ACTIVE_DEALER_SESSION_KEY);
            dispatch(addProductToCartSuccess(answer.data));
            if (!isInAuthor) {
                setPixelEvent(PixelEvent.ADD_TO_CART, {
                    prod_id: productDetailsPage.data?.key ?? '',
                    sku: head(sku) || '',
                    domain_key: bloomreachModel.productCatalog,
                });
            }
            sku.forEach((productSku) => {
                dispatch(decreaseStockProduct({
                    sku: productSku,
                    quantity,
                }));
            });
            broadcastCart.postMessage(isAddNewProduct
                ? CartBroadcastEvents.ADD_NEW_PRODUCT
                : CartBroadcastEvents.CHANGE_QUANTITY_PRODUCT);
        }
        catch (error) {
            const { response } = error;
            dispatch(addProductToCartFailure(response?.data));
            if (response &&
                [CartErrorMessage.NO_STOCK_LEFT, CartErrorMessage.NOT_ENOUGH_STOCK_LEFT].includes(response.data.error)) {
                sku.forEach((productSku) => {
                    dispatch(decreaseStockProduct({
                        sku: productSku,
                        quantity,
                        resetStock: true,
                    }));
                });
            }
        }
    };
};
async function processRequests({ pid, quantity, customerId, apiCartUrl, }) {
    const results = [];
    for (let i = 0; i < pid.length; i++) {
        const sku = pid[i];
        const formData = new FormData();
        formData.append('pid', sku);
        formData.append('quantity', String(i === 0 ? quantity : 1));
        formData.append('id', customerId);
        const axiosConfig = {
            method: METHOD_POST,
            url: apiCartUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data: formData,
        };
        try {
            const response = await axios.request(axiosConfig);
            results.push(response);
        }
        catch (error) { }
    }
    return results;
}
export const addProductToExternalCart = (pid, quantity = 1) => {
    const customerId = Cookies.get(EXTERNAL_CUSTOMER_ID);
    return async (dispatch, getState) => {
        const firstPid = head(pid) || '';
        dispatch(addProductToExternalCartRequest({
            pid: firstPid,
            quantity,
        }));
        if (customerId) {
            const { common: { externalCart: { hostettlerEndPoints: { domain, addToCartEndPoint }, }, language, bloomreachModel, isInAuthor, }, productCard: { labels: productCardLabels }, productDetailsPage, } = getState();
            const { common_error_label: labelError, common_tryAgain_label: labelTryAgain, hostettler_errorAddingRemovingItems_message: labelErrorAddingRemovingItems, hostettler_notPossibleToAddThisQuantity_message: labelNotPossibleToAddThisQuantity, hostettler_tooManyItemsOfTheSameProduct_message: labelTooManyItemsOfTheSameProduct, hostettler_tooManyTotalItems_message: labelTooManyTotalItems, } = productCardLabels;
            const apiCartUrl = `${domain}/${language.replace('-', '_')}/${addToCartEndPoint}`;
            try {
                const responses = await processRequests({
                    pid,
                    quantity,
                    customerId,
                    apiCartUrl,
                });
                const defaultProduct = responses[0]?.data;
                const errorCode = defaultProduct?.errorCode;
                if (!errorCode) {
                    dispatch(addProductExternalToCartFailure());
                    dispatch(setIsModalShowed({
                        type: MODALS.GENERAL_MESSAGE_MODAL,
                        data: {
                            state: ModalState.ERROR,
                            title: labelError,
                            description: labelErrorAddingRemovingItems,
                            primaryButtonContent: labelTryAgain,
                        },
                    }));
                }
                if (errorCode === HOSTETTLER_ERROR_STATES.SUCCESS_STATUS && defaultProduct) {
                    dispatch(addProductExternalToCartSuccess(defaultProduct));
                    if (!isInAuthor) {
                        setPixelEvent(PixelEvent.ADD_TO_CART, {
                            prod_id: productDetailsPage.data?.key ?? '',
                            sku: firstPid,
                            domain_key: bloomreachModel.productCatalog,
                        });
                    }
                    sessionStorage.removeItem(ACTIVE_DEALER_SESSION_KEY);
                }
                else {
                    let errorModalDescription = labelErrorAddingRemovingItems;
                    switch (errorCode) {
                        case HOSTETTLER_ERROR_STATES.ERROR_NOT_POSSIBLE_TO_ADD_THIS_QUANTITY:
                            errorModalDescription = labelNotPossibleToAddThisQuantity;
                            break;
                        case HOSTETTLER_ERROR_STATES.ERROR_TOO_MANY_ITEMS_OF_THE_SAME_PRODUCT:
                            errorModalDescription = labelTooManyItemsOfTheSameProduct;
                            break;
                        case HOSTETTLER_ERROR_STATES.ERROR_TOO_MANY_TOTAL_ITEMS_IN_CART:
                            errorModalDescription = labelTooManyTotalItems;
                            break;
                        default:
                            errorModalDescription = labelErrorAddingRemovingItems;
                            break;
                    }
                    dispatch(addProductExternalToCartFailure());
                    dispatch(setIsModalShowed({
                        type: MODALS.GENERAL_MESSAGE_MODAL,
                        data: {
                            state: ModalState.ERROR,
                            title: labelError,
                            description: errorModalDescription,
                            primaryButtonContent: labelTryAgain,
                        },
                    }));
                }
            }
            catch (error) {
                // const { response } = error as AxiosError; // TODO: next implementation related to Error handling scenarios
                dispatch(addProductExternalToCartFailure());
                dispatch(setIsModalShowed({
                    type: MODALS.GENERAL_MESSAGE_MODAL,
                    data: {
                        state: ModalState.ERROR,
                        title: labelError,
                        description: labelErrorAddingRemovingItems,
                        primaryButtonContent: labelTryAgain,
                    },
                }));
            }
        }
    };
};
export const getExternalCart = () => {
    const customerId = getCustomerId();
    return async (dispatch, getState) => {
        if (customerId) {
            const { common: { externalCart: { hostettlerEndPoints: { domain, cartInfoEndPoint }, isExternalCartEnabled, }, language, }, } = getState();
            if (isExternalCartEnabled) {
                const apiCartUrl = `${domain}/${language.replace('-', '_')}/${cartInfoEndPoint}?id=${customerId}`;
                try {
                    const axiosConfig = {
                        method: METHOD_GET,
                        url: apiCartUrl,
                    };
                    const answer = await axios.request(axiosConfig);
                    dispatch(getExternalCartSuccess(answer.data));
                }
                catch (error) {
                    dispatch(getExternalCartFailure());
                }
            }
        }
    };
};
export const getCart = (apiUrl = '', hasSpinner = false, successCallback) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    return async (dispatch, getState) => {
        if (cartId) {
            const { common: { languageRootPath }, cart: { hyperdriveEndpoints }, } = getState();
            const apiUrlCart = apiUrl || hyperdriveEndpoints.getCartById;
            if (hasSpinner) {
                dispatch(getCartRequest());
            }
            try {
                const axiosConfig = {
                    method: METHOD_GET,
                    url: apiUrlCart.replace(CART_ID_SEPARATOR, cartId),
                };
                const answer = await axios.request(axiosConfig);
                dispatch(getCartSuccess(answer.data));
                if (successCallback) {
                    successCallback();
                }
            }
            catch (error) {
                const { response } = error;
                if (response?.status === HTTPStatusCode.NotFound) {
                    Cookies.remove(COOKIE_CART_ID_KEY, {
                        path: `${languageRootPath}/`,
                    });
                }
                dispatch(getCartFailure());
            }
        }
    };
};
export const changeShippingMethod = (methodName) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    return async (dispatch, getState) => {
        const { cart: { hyperdriveEndpoints }, } = getState();
        try {
            const axiosConfig = {
                data: {
                    actions: [
                        {
                            action: CartAction.SET_SHIPPING_METHOD,
                            value: {
                                methodName,
                                typeId: TypeId.SHIPPING_METHOD,
                            },
                        },
                    ],
                },
                method: METHOD_POST,
                url: hyperdriveEndpoints.getCartById.replace(CART_ID_SEPARATOR, cartId),
            };
            const answer = await axios.request(axiosConfig);
            dispatch(changeShippingMethodSuccess(answer.data));
        }
        catch (_error) {
            dispatch(changeShippingMethodFailure());
            dispatch(setIsModalShowed({
                type: MODALS.SHOPPING_CART_ERROR,
            }));
        }
    };
};
export const deleteCartItems = (projectId) => async (dispatch, getState) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    const { cart, common } = getState();
    dispatch(setIsLoadingCart(true));
    dispatch(setDeletingCartItems());
    try {
        const axiosConfig = {
            method: METHOD_POST,
            url: CHECKOUT_RELEASE_INVENTORY,
            data: {
                cartId: cartId || cart.data?.id,
                project: common.commercetoolsProjectKey || projectId,
            },
        };
        await axios.request(axiosConfig);
    }
    finally {
        dispatch(setIsLoadingCart(false));
    }
};
export const changeItemQuantity = (sku, quantity) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    return async (dispatch, getState) => {
        dispatch(changeItemQuantityRequest({
            sku,
            quantity,
        }));
        const { cart: { hyperdriveEndpoints }, checkout: { labels: checkoutLabels }, } = getState();
        try {
            const axiosConfig = {
                data: {
                    actions: [
                        {
                            action: CartAction.CHANGE_LINE_ITEM_QUANTITY,
                            value: {
                                quantity,
                                sku,
                            },
                        },
                    ],
                },
                method: METHOD_POST,
                url: hyperdriveEndpoints.getCartById.replace(CART_ID_SEPARATOR, cartId),
            };
            const answer = await axios.request(axiosConfig);
            broadcastCart.postMessage(quantity === 0
                ? CartBroadcastEvents.REMOVE_PRODUCT
                : CartBroadcastEvents.CHANGE_QUANTITY_PRODUCT);
            dispatch(changeItemQuantitySuccess(answer.data));
            // B2C-20664
            if (quantity === 0) {
                sessionStorage.removeItem(ACTIVE_DEALER_SESSION_KEY);
            }
            if (quantity === 0 && answer.data?.entries.length) {
                dispatch(getShippingMethods());
            }
        }
        catch (error) {
            const { response } = error;
            if (response &&
                [CartErrorMessage.NO_STOCK_LEFT, CartErrorMessage.NOT_ENOUGH_STOCK_LEFT].includes(response.data.error)) {
                const { data } = response;
                dispatch(setIsModalShowed({
                    type: MODALS.GENERAL_MESSAGE_MODAL,
                    data: {
                        state: ModalState.WARNING,
                        title: checkoutLabels.checkout_changeStockErrorPopUp_header,
                        description: checkoutLabels.checkout_changeStockErrorPopUp_message,
                        primaryButtonContent: checkoutLabels.checkout_IUnderstand_button,
                    },
                }));
                dispatch(updateStockQuantityProduct({
                    sku,
                    stock: data.stock,
                    quantity: data.inCart,
                }));
                dispatch(setCartErrorData({
                    ...data,
                    sku,
                }));
            }
            else {
                dispatch(setIsModalShowed({
                    type: MODALS.SHOPPING_CART_ERROR,
                }));
            }
            dispatch(changeItemQuantityFailure());
        }
    };
};
export const getShippingMethods = () => async (dispatch, getState) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    const { common: { commercetoolsProjectKey }, cart, checkout: { isPickUpAtDealerDisabled }, } = getState();
    const hasProductDeliverAtDealerOnly = getHasProductDeliverAtDealerOnly(cart.data?.entries ?? []);
    const shippingMethodName = cart.data?.shippingInfo?.name;
    try {
        const axiosConfig = {
            method: METHOD_POST,
            url: SHIPPING_METHODS_ENDPOINT,
            data: {
                cartId,
                projectKey: commercetoolsProjectKey,
            },
        };
        const answer = await axios.request(axiosConfig);
        if (!answer.data.length)
            return;
        const mappedAnswerData = answer.data.map((item) => item.name);
        dispatch(getShippingMethodsSuccess(answer.data));
        if (hasProductDeliverAtDealerOnly && isPickUpAtDealerDisabled)
            return;
        if (!shippingMethodName && !hasProductDeliverAtDealerOnly && !isPickUpAtDealerDisabled) {
            dispatch(changeShippingMethod(answer.data[0].name));
            return;
        }
        if ((!shippingMethodName ||
            ShippingMethodsGroups.HOME.includes(shippingMethodName)) &&
            hasProductDeliverAtDealerOnly) {
            const equalMethods = intersection(mappedAnswerData, ShippingMethodsGroups.DEALER);
            equalMethods[0] && dispatch(changeShippingMethod(equalMethods[0]));
            return;
        }
        if ((!shippingMethodName ||
            ShippingMethodsGroups.DEALER.includes(shippingMethodName)) &&
            isPickUpAtDealerDisabled) {
            const equalMethods = intersection(mappedAnswerData, ShippingMethodsGroups.HOME);
            equalMethods[0] && dispatch(changeShippingMethod(equalMethods[0]));
            return;
        }
        if (!answer.data.some((item) => item.name === shippingMethodName)) {
            const currentGroupMethods = Object.values(ShippingMethodsGroups).find((groupMethods) => groupMethods.includes(shippingMethodName));
            const equalMethods = intersection(mappedAnswerData, currentGroupMethods ?? []);
            dispatch(changeShippingMethod(equalMethods[0] || answer.data[0].name));
        }
    }
    catch (_error) {
        // TODO: handle error
    }
};
export const addDiscountCode = (code) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    return (dispatch, getState) => {
        const { cart: { hyperdriveEndpoints }, } = getState();
        const axiosConfig = {
            data: {
                actions: [
                    {
                        action: CartAction.ADD_DISCOUNT_CODE,
                        value: {
                            code,
                        },
                    },
                ],
            },
            method: METHOD_POST,
            url: hyperdriveEndpoints.getCartById.replace(CART_ID_SEPARATOR, cartId),
        };
        dispatch(serviceAPI(axiosConfig, {
            request: updateDiscountCodeRequest,
            success: function onSuccess(response) {
                setDigitalData(DigitalDataMutation.ADD_PROMOCODE, {
                    code,
                    cart: response.data,
                });
                return updateDiscountCodeSuccess(response);
            },
            failure: updateDiscountCodeFailure,
        }));
    };
};
export const removeDiscountCode = () => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    return async (dispatch, getState) => {
        dispatch(updateDiscountCodeRequest());
        const { cart: { hyperdriveEndpoints, data: cartData }, common: { labels: commonLabels }, checkout: { labels: checkoutLabels }, } = getState();
        try {
            const axiosConfig = {
                data: {
                    actions: [
                        {
                            action: CartAction.REMOVE_DISCOUNT_CODE,
                            value: {
                                code: cartData?.discountCodes[0].code,
                            },
                        },
                    ],
                },
                method: METHOD_POST,
                url: hyperdriveEndpoints.getCartById.replace(CART_ID_SEPARATOR, cartId),
            };
            const answer = await axios.request(axiosConfig);
            setDigitalData(DigitalDataMutation.REMOVE_PROMOCODE, {
                code: cartData?.discountCodes[0].code ?? '',
                cart: answer.data,
            });
            dispatch(updateDiscountCodeSuccess(answer));
        }
        catch (error) {
            const { response } = error;
            const isPromocodeNotAvailableInCart = response?.data.error === CartErrorMessage.PROMOCODE_NOT_AVAILABLE_IN_CART;
            if (isPromocodeNotAvailableInCart) {
                dispatch(getCart());
            }
            dispatch(setIsModalShowed({
                type: MODALS.GENERAL_MESSAGE_MODAL,
                data: {
                    state: ModalState.ERROR,
                    title: commonLabels.common_popUpError_header,
                    description: isPromocodeNotAvailableInCart
                        ? checkoutLabels.checkout_orderReviewDiscountCodeNotAvailable_error
                        : checkoutLabels.common_somethingWentWrong_message,
                    primaryButtonContent: commonLabels.common_popUpError_button,
                },
            }));
            dispatch(setIsLoadingCart(false));
        }
    };
};
export const getHashedCartId = () => async (dispatch, getState) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    const { checkout: { dealersTools: { hyperdriveEndpoints: { hashedCartIdEndpoint }, }, }, } = getState();
    dispatch(setIsLoadingCart(true));
    try {
        const axiosConfig = {
            data: {
                cartId,
            },
            method: METHOD_POST,
            url: hashedCartIdEndpoint,
        };
        const answer = await axios.request(axiosConfig);
        dispatch(setCartQrId(answer.data.cartQrId));
        dispatch(setIsModalShowed({
            type: MODALS.SHARE_CART_BY_QR_MODAL,
        }));
    }
    catch (error) {
        const { response } = error;
        if ([
            HTTPStatusCode.BadRequest,
            HTTPStatusCode.NotFound,
            HTTPStatusCode.UnprocessableContent,
            HTTPStatusCode.InternalServerError,
        ].includes(response?.status)) {
            dispatch(setIsModalShowed({
                type: MODALS.GENERATE_QR_ERROR_MODAL,
            }));
        }
        else {
            dispatch(setIsModalShowed({
                type: MODALS.SHOPPING_CART_ERROR,
            }));
        }
    }
    finally {
        dispatch(setIsLoadingCart(false));
    }
};
export const getCartIdByHash = (hashedCartId, cartIdByHashEndpoint, dealersLabels, updateQueryParams) => async (dispatch, getState) => {
    const { common: { languageRootPath, labels: commonLabels }, } = getState();
    dispatch(setIsLoadingCart(true));
    dispatch(setInitialCartState());
    Cookies.remove(COOKIE_CART_ID_KEY, {
        path: `${languageRootPath}/`,
    });
    Cookies.remove(PAYMENT_LINK_PROVIDER, {
        path: `${languageRootPath}/`,
    });
    updateQueryParams();
    try {
        const axiosConfig = {
            data: {
                cartQrId: hashedCartId,
            },
            method: METHOD_POST,
            url: cartIdByHashEndpoint,
        };
        const answer = await axios.request(axiosConfig);
        Cookies.set(COOKIE_CART_ID_KEY, answer.data.cartId, {
            expires: COOKIE_CART_ID_EXPIRE,
            path: `${languageRootPath}/`,
        });
        dispatch(getCart('', true));
    }
    catch (error) {
        dispatch(setIsLoadingCart(false));
        dispatch(setIsModalShowed({
            type: MODALS.GENERAL_MESSAGE_MODAL,
            data: {
                state: ModalState.ERROR,
                title: dealersLabels.checkout_dealersToolsOpenCartExpiredPopUp_header,
                description: dealersLabels.checkout_dealersToolsOpenCartExpiredPopUp_description,
                primaryButtonContent: commonLabels.common_popUpError_button,
            },
        }));
    }
};
export const sendCartByEmail = (name, email) => async (dispatch, getState) => {
    const cartId = Cookies.get(COOKIE_CART_ID_KEY);
    const { common: { labels: commonLabels, languageRootPath, language, pdpLinks, isInAuthor, commercetoolsProjectKey, }, profileData: { profileDealerInfo, data }, cart: { data: cartData }, checkout: { dealersTools: { labels: dealersLabels }, }, } = getState();
    dispatch(setIsLoadingCart(true));
    try {
        const axiosConfig = {
            method: METHOD_POST,
            data: {
                name,
                email,
                domain: window.location.origin,
                cartLink: generateCartLink(cartId, data?.customAttributes?.userAccountDealerId),
                cartId,
                projectKey: commercetoolsProjectKey,
                language: getFormattedLanguageRoot(language),
                dealer: {
                    name: profileDealerInfo?.name,
                    street: profileDealerInfo?.addressLines.join(' ').trim(),
                    city: profileDealerInfo?.city,
                    countryCode: profileDealerInfo?.country,
                    postalCode: profileDealerInfo?.zipCode,
                },
                products: getProductsDataForEmail(cartData?.entries, pdpLinks, isInAuthor),
            },
            url: SHARE_CART_VIA_EMAIL_ENDPOINT,
        };
        await axios.request(axiosConfig);
        dispatch(setIsModalShowed({
            type: MODALS.GENERAL_MESSAGE_MODAL,
            data: {
                state: ModalState.SUCCESS,
                title: dealersLabels.checkout_dealersToolsShareViaEmailPopUp_header,
                description: dealersLabels.checkout_dealersToolsShareViaEmailSuccessPopUp_description,
                primaryButtonContent: commonLabels.common_popUpError_button,
            },
        }));
        Cookies.set(DEALER_CART_SHARED_ID, cartId, {
            expires: COOKIE_CART_ID_EXPIRE,
            path: `${languageRootPath}/`,
        });
    }
    catch (error) {
        dispatch(setIsModalShowed({
            type: MODALS.SHOPPING_CART_ERROR,
        }));
    }
    finally {
        dispatch(setIsLoadingCart(false));
    }
};
